export default "__VITE_ASSET__0e3f3ed9__"